/**
 * Validity periods of the one-time links the auth-server mails out. The schema
 * only stores *when a link expires* (`…OtpValidUntil`), not when it was
 * created, so the creation time is derived from these constants. They mirror
 * pim-auth-server's `invitation.workflow.ts` / `reset-password.workflow.ts`;
 * keep them in sync when those change.
 */
export const INVITATION_OTP_TTL_MS = 14 * 24 * 60 * 60 * 1000;
export const RESET_PASSWORD_OTP_TTL_MS = 6 * 60 * 60 * 1000;

export type OtpWindow = {
  /** Derived: expiry minus the link's validity period. */
  createdAt: Date;
  validUntil: Date;
  expired: boolean;
};

/** Describe an open one-time link from its expiry, or null if there is none. */
export function otpWindow(
  validUntil: string | null | undefined,
  ttlMs: number,
  now: Date = new Date(),
): OtpWindow | null {
  if (!validUntil) {
    return null;
  }
  const until = new Date(validUntil);
  if (!Number.isFinite(until.getTime())) {
    return null;
  }
  return {
    createdAt: new Date(until.getTime() - ttlMs),
    validUntil: until,
    expired: until.getTime() < now.getTime(),
  };
}
